import api from "./helper/client";

export interface AppSettings {
    id: number;
    tenant_id: number;
    dev_mode: boolean;
    da_requires_visit: boolean;
    ta_requires_visit: boolean;
    location_update_enabled: boolean;
    created_at: string;
    updated_at: string;
}

export const getAppSettings = async (tenantId: number): Promise<AppSettings> => {
    const response = await api.get(`/app-settings/${tenantId}`);
    return response.data.data;
};

export const updateAppSettings = async (
    tenantId: number,
    patch: Partial<Pick<AppSettings, "dev_mode" | "da_requires_visit" | "ta_requires_visit" | "location_update_enabled">>
): Promise<AppSettings> => {
    const response = await api.put(`/app-settings/${tenantId}`, patch);
    return response.data.data;
};
